"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "castelli-calepio": {
    "e7f17665": [{
      "hkey": "c2a46e3e",
      "slug": "cividino-quintano",
      "name": "Cividino-Quintano",
      "primary": true,
      "skipSearch": false
    }],
    "cividino": [{
      "hkey": "c2a46e3e",
      "slug": "cividino-quintano",
      "name": "Cividino-Quintano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f05a1b5a": [{
      "hkey": "c2a46e3e",
      "slug": "cividino-quintano",
      "name": "Cividino-Quintano",
      "primary": true,
      "skipSearch": false
    }],
    "quintano": [{
      "hkey": "c2a46e3e",
      "slug": "cividino-quintano",
      "name": "Cividino-Quintano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "castelli-calepio"
    }]
  }
};
exports["default"] = _default;